export default __webpack_public_path__ + "static/media/cst-round.d052852d.png";